import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-sprite-svg',
  templateUrl: './svg-sprite.svg',
  styleUrls: ['./sprite-svg.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class SpriteSvgComponent {}
